export const TAG_TYPE = {
  DEFAULT: 'default',
  BRAND: 'brand',
  WARNING: 'warning',
  DEALS: 'deals',
  DANGER: 'danger',
};
